import LegalPage from "@/components/LegalPage";
import { SITE } from "@/lib/site";

export default function Privacy() {
  return (
    <LegalPage
      title="Privacy Policy"
      description="How AUT labs collects, uses, protects and retains personal information submitted through this website."
      updated="13 August 2026"
      intro="This policy explains what we collect through this website, why we collect it, and the choices available to you."
    >
      <section>
        <h2>1. Information we collect</h2>
        <p>
          When you book a call, ask for a callback, email, call or message us, we may
          receive your name, company, phone number, email address, scheduling details and
          anything you choose to tell us about your business.
        </p>
        <p>
          Our hosting and security providers may also process basic technical records such
          as IP address, browser type, requested page and time of access. The current site
          does not use advertising trackers or sell visitor profiles.
        </p>
      </section>

      <section>
        <h2>2. Why we use it</h2>
        <p>We use this information to:</p>
        <ul>
          <li>respond to your enquiry and arrange a call;</li>
          <li>understand whether AUT labs can help;</li>
          <li>prepare and perform work you ask us to consider;</li>
          <li>protect, maintain and improve the website; and</li>
          <li>meet legal, security and record-keeping obligations.</li>
        </ul>
        <p>We do not sell personal data or use enquiry details for unrelated model training.</p>
      </section>

      <section>
        <h2>3. When we share information</h2>
        <p>
          We share information only when needed with providers that help us host the site,
          schedule calls, communicate or secure our systems; with professional advisers;
          or where disclosure is required by law. Calendar, WhatsApp, phone and email
          services have their own privacy practices when you choose to use them.
        </p>
      </section>

      <section>
        <h2>4. Client and project data</h2>
        <p>
          If we begin a project, confidentiality, security, access, retention and deletion
          requirements for company data are agreed in the relevant proposal or service
          agreement. Client data is not used to train unrelated systems or models.
        </p>
      </section>

      <section>
        <h2>5. Retention and security</h2>
        <p>
          We retain enquiry information only as long as reasonably needed for the purpose
          described above, an ongoing business relationship, or legal requirements. We use
          reasonable organisational and technical safeguards, but no internet service can
          promise absolute security.
        </p>
      </section>

      <section>
        <h2>6. Your choices and rights</h2>
        <p>
          You may ask what personal information we hold about you, request correction or
          erasure where applicable, withdraw consent, or raise a grievance. Email{" "}
          <a href={`mailto:${SITE.email}`}>{SITE.email}</a>. We may need to verify your
          identity before acting on a request.
        </p>
      </section>

      <section>
        <h2>7. Children</h2>
        <p>
          This business website is not directed to children, and we do not knowingly seek
          personal data from anyone under 18 through it.
        </p>
      </section>

      <section>
        <h2>8. Changes and contact</h2>
        <p>
          We may update this policy when the website, our services or applicable requirements
          change. The effective date above shows the latest version. Privacy questions and
          grievances can be sent to <a href={`mailto:${SITE.email}`}>{SITE.email}</a>.
        </p>
      </section>
    </LegalPage>
  );
}
